<template>
  <DashboardLayout>
    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <p class="mb-0 main-identifier fw-semibold">User Functions</p>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Edit Role</p>
    </div>

    <div class="d-flex justify-content-center">
      <div class="form-outer">
        <form @submit.prevent="handleSubmit">
          <div class="crud-form position-relative">
            <!-- <button type="button" class="close-button" @click="handleClose">
                        &times;
                    </button> -->

            <div class="form-inner">
              <div class="form-header d-flex justify-content-between align-items-center">
                <h1 class="mb-0">Edit Role</h1>
              </div>

              <!-- <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p> -->
              <div class="form-body">
                <div class="row mt-2 mb-3">
                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                      <label for="roleName" class="form-label">Role Name</label>
                    </div>
                    <div class="col-md-10 input-right">
                      <input type="text" class="form-control" id="roleName" v-model="newRoleName"
                        :placeholder="currentRoleName !== null ? currentRoleName : ''" required />
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                      <label for="first_name">Description</label>
                    </div>
                    <div class="col-md-10 input-right">
                      <textarea class="form-control" id="description" v-model="newDescription"
                        :placeholder="currentDescription !== null ? currentDescription : ''" rows="3"
                        required></textarea>
                    </div>
                  </div>

                  <!-- Hidden field to store version -->
                  <input type="hidden" v-model="form.createdBy" />
                  <input type="hidden" v-model="form.lastModBy" />
                  <input type="hidden" v-model="form.entityId" />

                  <div class="d-flex justify-content-center">
                    <button class="submit-btn" type="submit" :disabled="isLoading">
                      {{ isLoading ? "Submitting..." : "Submit" }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </DashboardLayout>
</template>

<script setup>
import axios from "axios";
import Cookies from "js-cookie";
import { ref, onMounted, reactive, watch } from "vue";
import { useRoute } from 'vue-router'
import DashboardLayout from "../layout/DashboardLayout.vue";
import Swal from "sweetalert2";

const isLoading = ref(false);
const errorMessage = ref("");
const loadingDetail = ref(false)
const detailError = ref(null)

const selectedId = ref('')
const currentRoleName = ref("");
const currentDescription = ref("");
const form = reactive({
  createdBy: "",
  lastModBy: "",
  entityId: "",
});

const newRoleName = ref("");
const newDescription = ref("");

const root_api_url = process.env.VUE_APP_API_ROOT_URL;
const route = useRoute()
const rid = route.params.id

const fetchRole = async () => {
  const token = Cookies.get('auth_token')
  try {
    const response = await axios.get(`${root_api_url}/auth/role/${rid}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })

    const roleData = response.data
    currentRoleName.value = roleData.roleName || ''
    currentDescription.value = roleData.description || ''
    form.createdBy = roleData.createdBy || ''
    form.lastModBy = roleData.lastModBy || ''
    form.entityId = roleData.entityId || ''
    // Clear new values (placeholder approach)
    newRoleName.value = ''
    newDescription.value = ''

    // console.log("Roles response: ", response.data);
  } catch (error) {
    console.error('Failed to fetch roles:', error)
  }
}

const fetchSelectedRole = async (id) => {
  if (!id) return
  loadingDetail.value = true
  detailError.value = null
  try {
    const token = Cookies.get('auth_token')
    const resp = await axios.get(`${root_api_url}/auth/role/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
    const data = resp.data
    currentRoleName.value = data.roleName || ''
    currentDescription.value = data.description || ''
    form.createdBy = data.createdBy || ''
    form.lastModBy = data.lastModBy || ''
    form.entityId = data.entityId || ''
    // Clear new values (placeholder approach)
    newRoleName.value = ''
    newDescription.value = ''

  } catch (err) {
    console.error('Failed to fetch role details', err)
    detailError.value = 'Failed to load details'
  } finally {
    loadingDetail.value = false
  }
}

// Watch dropdown selection
watch(selectedId, (newId) => {
  if (!newId) {
    currentRoleName.value = ''
    currentDescription.value = ''
    newRoleName.value = ''
    newDescription.value = ''
  } else {
    fetchSelectedRole(newId)
  }
})

async function handleSubmit() {
  const token = Cookies.get("auth_token");

  if (!token) {
    alert("You must be logged in to perform this action.");
    return;
  }

  if (!selectedId.value) {
    Swal.fire('Please select a Role first')
    return
  }

  const roleName = newRoleName.value !== '' ? newRoleName.value : currentRoleName.value
  const description = newDescription.value !== '' ? newDescription.value : currentDescription.value
  const roleData = {
    roleName,
    description,
    createdBy: form.createdBy,
    lastModBy: form.lastModBy,
    entityId: form.entityId
  };

  // console.log("Submitting role data:", roleData);
  isLoading.value = true;
  errorMessage.value = "";
  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`;
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`;

  try {
    const response = await axios.put(`${root_api_url}/auth/role`, roleData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200 || response.status === 201) {
      Swal.fire({
        // title: 'Success!',
        html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Role Edited successfully!</p> `,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
      roleName.value = "";
      description.value = "";
    } else {
      errorMessage.value = "Failed to edit role.";
      Swal.fire({
        html: `${iconHtmlError}
                  <h1 style="font-weight:600;">Error</h1>
                  <p>Failed to edit role.</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    }
  } catch (err) {
    if (err?.response?.status === 400) {
      errorMessage.value = "Invalid data provided.";
    } else if (err?.response?.status === 403) {
      errorMessage.value = "Unauthorized. Please log in again.";
    } else if (err?.response?.status === 503) {
      errorMessage.value = "Service unavailable. Please try again later.";
    } else {
      errorMessage.value = "Unexpected error occurred, kindly contact administrator.";
    }
    Swal.fire({
      html: `${iconHtmlError}
              <h1 style="font-weight:600;">Error</h1>
              <p>${errorMessage.value}</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });
  } finally {
    isLoading.value = false;
  }


}

onMounted(() => {
  fetchRole(),
  document.title = "Edit Role"
})
</script>
